/**
 * Who sees the AI Assistant's entry points (top-bar icon in Layout, Cmd-K entry).
 * System admins only for now (Andrey, 2026-10-15). The page itself is gated by
 * the API (/api/sales-assistant), so this decides visibility, not access.
 * See docs/features/sales-assistant.md → "Where to find it".
 */
export const canSeeAssistantEntry = (user: { is_system_admin?: boolean } | null | undefined): boolean =>
  user?.is_system_admin === true;
